import React from "react"
import { Pressable, Text, View, Image, DeviceEventEmitter } from "react-native";

import { debounce } from "lodash";
import { store } from "../store/store";
import { View as AnimatableView, } from "react-native-animatable";

import { reformatLocationString } from "../utils/services/ReformatUtils";
import { getOrderSnackBarData } from "../utils/services/oms/SnackBarUtils";
import { getCartTotalItemCount } from "../utils/services/oms/UpsertCartData";
import { checkIsAddressCompleted } from "../utils/services/user/UserAddressUtils";
import { getImagePath, isChemistStoreLoaded, isStandAloneApp } from "../utils/services/CommonUtils";
import { CommonSupportHeader, CommonTooltipHeader } from "../utils/widgets/CommonWidget/CommonHeader";
import { getCartItemFroRedux, getCartImagesFromRedux, calculateCartAmount, getOrderSavingsAmount } from "../utils/services/oms/OMSCartUtils";

import { IconView } from "../utils/widgets/CommonWidget/Icons";
import { BottomSnackBarView } from "../utils/widgets/SnackBarView";
import { EstimatedPriceView } from "../utils/widgets/cart/EstimatedPriceBottomSheet";

import { IndiaRupee } from "../utils/constants/AppConstants";
import { ScreenRoute } from "../utils/constants/ScreenRouteConstant";
import { ActionFromParent } from "../utils/constants/ConstantsMapping";

import AppTheme from "../AppTheme";
import TextStyle from "../TextStyle";
import AppStyles, { ComponentViewStyle } from "../AppStyles";

import ProfileComponent from "./tab-component/ProfileComponent";
import OrderComponent from "./tab-component/OrderListComponent";
import CartViewComponent from "./tab-component/CartViewComponent";
import DashboardComponent from "./tab-component/DashboardComponent";
import ChemistStoreComponent from "./tab-component/ChemistStoreComponent";

import SupportViewModal from "../utils/modals/SupportViewModal";
import CartIconAnimation from "../utils/widgets/Animations/CartIconAnimation";

class TabControllerView extends React.Component<any, any> {
    constructor(props) {
        super(props);
        const reduxState: any = store.getState();
        this.state = {
            activeTab: props.route.name,

            isUserLoggedIn: reduxState.isUserLogin,

            cartProducts: [],
            prescriptionData: [],

            cartItemCount: 0,
            cartTotalAmount: 0,

            selectedLocation: {},

            orderSnackBarData: [],

            chemistStoreLoaded: isChemistStoreLoaded(),

            supportModal: false
        };
    }

    showSupportModal = () => { this.setState({ supportModal: true }) }
    closeSuportModal = () => { this.setState({ supportModal: false }) }

    componentDidMount() {
        if (!this.state.chemistStoreLoaded)
            this.props.navigation.navigate(ScreenRoute.splash)
        this.setState({ activeTab: this.props.route.name })
        this.orderSubscriptions()
        this.cartDataSubscription()
        store.subscribe(() => {
            this.orderSubscriptions()
            this.cartDataSubscription()
        })
    }

    cartDataSubscription = debounce(this.updateCartData, AppTheme.debouceTimeout)
    orderSubscriptions = debounce(this.getOrderData, AppTheme.debouceTimeout + 100)

    updateCartData() {
        let cartItems = getCartItemFroRedux()
        let cartImageList = getCartImagesFromRedux()
        let cartItemCount = getCartTotalItemCount()
        let cartTotalAmount = calculateCartAmount(cartItems)
        this.setState({
            cartProducts: cartItems,
            prescriptionData: cartImageList,
            cartItemCount: cartItemCount,
            cartTotalAmount: cartTotalAmount,
        });
    }

    getOrderData() {
        if (this.state.chemistStoreLoaded)
            this.setState({ orderSnackBarData: getOrderSnackBarData() })
    }

    setSelectedLocation(location) {
        this.setState({ selectedLocation: location })
    }

    getBottomCTATitle() {
        if (checkIsAddressCompleted(this.state.selectedLocation))
            return 'Place Order'
        else return 'Select Address'
    }

    bottomCTAFunction() {
        let action = ''
        if (this.state.isUserLoggedIn) {
            if (checkIsAddressCompleted(this.state.selectedLocation))
                action = ActionFromParent.placeOrder
            else action = ActionFromParent.selectLocationInCart
        } else action = ActionFromParent.addNewAddress
        DeviceEventEmitter.emit('actionFromParent', { action: action });
    }

    disableOrderCTA() {
        if ((this.state.cartProducts && this.state.cartProducts?.length) ||
            (this.state.prescriptionData && this.state.prescriptionData?.length))
            return false;
        else return true;
    }

    getHomeBottomPadding() {
        let padding = AppTheme.bottomNavBarHeight
        if (this.state.orderSnackBarData.length)
            padding += AppTheme.homeSnackBarHeight
        if (isStandAloneApp()) padding -= 60
        return padding
    }

    getCartBottomPadding() {
        let padding = AppTheme.bottomNavBarHeight
        if (getOrderSavingsAmount(this.state?.cartProducts) > 0)
            padding += AppTheme.totalSavingHeight
        if (getCartTotalItemCount() > 0)
            padding += AppTheme.estimatedPriceBarHeight
        return padding
    }

    render() {
        return <View>

            {/* Tab component View */}
            <View style={AppStyles.fullScreenView}>

                {this.state.activeTab == ScreenRoute.home && <AnimatableView
                    key={'home tab'} animation="fadeInLeft"
                    duration={AppTheme.tabTransitionDuration}
                    style={[ComponentViewStyle.tabComponent]}>
                    {this.state.chemistStoreLoaded ?
                        <ChemistStoreComponent getBottomPadding={() => this.getHomeBottomPadding()}
                            navigation={this.props.navigation} route={this.props.route} /> :
                        <DashboardComponent getBottomPadding={() => this.getHomeBottomPadding()}
                            navigation={this.props.navigation} route={this.props.route} />}
                </AnimatableView>}

                {this.state.activeTab == ScreenRoute.cart && <View>
                    <CommonTooltipHeader title='My Cart'
                        selectedLocation={this.state.selectedLocation}
                        toolTipView={() => this.SelectedLocationView()}
                        toolTipContainerView={() => this.SelectedLocationInfo()}
                        locationIconView={() => this.ChangeLocationIconView()} />
                    <AnimatableView key={'cart tab'} animation="fadeInLeft"
                        duration={AppTheme.tabTransitionDuration}
                        style={[ComponentViewStyle.tabComponentWithHeader]}>
                        <CartViewComponent getBottomPadding={() => this.getCartBottomPadding()}
                            navigation={this.props.navigation} route={this.props.route}
                            setSelectedLocation={(location) =>
                                this.setSelectedLocation(location)} /></AnimatableView>
                </View>}

                {this.state.activeTab == ScreenRoute.orders && <View>
                    <CommonSupportHeader title='My Orders'
                        showSupportModal={this.showSupportModal} />
                    <View key={'order tab'}
                        style={[ComponentViewStyle.tabComponentWithHeader,
                        { paddingBottom: AppTheme.bottomNavBarHeight }]}>
                        <OrderComponent navigation={this.props.navigation}
                            route={this.props.route} /></View></View>}

                {this.state.activeTab == ScreenRoute.profile && <AnimatableView
                    key={'profile tab'} animation="fadeInLeft"
                    duration={AppTheme.tabTransitionDuration}
                    style={[ComponentViewStyle.tabComponent,
                    { paddingBottom: AppTheme.bottomNavBarHeight }]}>
                    <ProfileComponent navigation={this.props.navigation}
                        route={this.props.route} /></AnimatableView>}

            </View>

            {this.state.activeTab == ScreenRoute.home &&
                this.state.orderSnackBarData.length > 0 &&
                <BottomSnackBarView orderList={this.state.orderSnackBarData}
                    navigation={this.props.navigation} />}

            {this.state.activeTab == ScreenRoute.cart && this.state.cartItemCount ?

                <View>
                    {getOrderSavingsAmount(this.state?.cartProducts) > 0 ?
                        <View style={[AppStyles.bottomFix, AppStyles.py6, AppStyles.alignCenter, {
                            marginBottom: AppTheme.bottomNavBarHeight + AppTheme.estimatedPriceBarHeight,
                            backgroundColor: AppTheme.color.green.primary
                        }]}><Text style={[TextStyle.text12, TextStyle.colorWhite, TextStyle.alignCenter]}>
                                Your total savings on this order is <Text style={TextStyle.text12b}>
                                    {IndiaRupee}{getOrderSavingsAmount(this.state.cartProducts)}</Text></Text>
                        </View> : null}
                    <EstimatedPriceView
                        ctaTitle={this.getBottomCTATitle()}
                        ctaAction={() => this.bottomCTAFunction()}
                        isCtaDisabled={this.disableOrderCTA()}
                        cartTotalAmount={this.state.cartTotalAmount}
                        viewStyle={{ marginBottom: AppTheme.bottomNavBarHeight }} />

                </View> : null}

            {/* Tab Bar View */}
            <View style={[ComponentViewStyle.tabBar]}>
                <this.TabIconView title={'Home'} iconName={'home'} tabName={ScreenRoute.home}
                    navigation={this.props.navigation} activeTab={this.state.activeTab} />
                <Pressable onPress={() => this.props.navigation.replace(ScreenRoute.cart)}>
                    <CartIconAnimation isActive={this.state.activeTab == ScreenRoute.cart} />
                    <Text style={[TextStyle.text10xb, {
                        marginTop: 6, color: this.state.activeTab == ScreenRoute.cart ?
                            AppTheme.color.primary : AppTheme.color.grey.disable
                    }]} onPress={() => this.props.navigation.replace(ScreenRoute.cart)}>
                        {'Cart'}</Text>
                </Pressable>
                <this.TabIconView title={'Orders'} iconName={'order'} tabName={ScreenRoute.orders}
                    navigation={this.props.navigation} activeTab={this.state.activeTab} />
                <this.TabIconView title={'Profile'} iconName={'profile'} tabName={ScreenRoute.profile}
                    navigation={this.props.navigation} activeTab={this.state.activeTab} />
            </View>

            {this.state.supportModal && <SupportViewModal
                showPopup={this.state.supportModal}
                closeModal={this.closeSuportModal} />}

        </View>
    }

    TabIconView(props) {
        let title = props.title
        let iconName = props.iconName
        let tabName = props.tabName
        let activeTab = props.activeTab
        return <Pressable onPress={() => props.navigation.replace(tabName)}>
            <AnimatableView animation="fadeIn" style={{ alignItems: "center" }}
                duration={AppTheme.transitionDuration} key={tabName}>
                <Image source={{
                    uri: getImagePath(activeTab == tabName ?
                        '/images/navBar/' + iconName + '_blue.svg' :
                        '/images/navBar/' + iconName + '_grey.svg')
                }} style={{ width: 20, height: 16 }} />
                <Text style={[TextStyle.text10xb, {
                    marginTop: 6, color: activeTab == tabName ?
                        AppTheme.color.primary : AppTheme.color.grey.disable
                }]} >{title}</Text>
            </AnimatableView>
        </Pressable>
    }

    SelectedLocationView() {
        return <View key={'tooltip_cart_tab'} style={[AppStyles.flexRowEnd]}>
            <IconView width={13} height={19} icon={'location/blue.svg'} />
            <Text ellipsizeMode="tail" numberOfLines={1} style={[TextStyle.text16b,
            { marginHorizontal: 6, maxWidth: AppTheme.appWidth / 2 }]}>
                {this.state.selectedLocation?.name}</Text>
        </View>
    }

    SelectedLocationInfo() {
        let location = this.state.selectedLocation
        return <Text style={[TextStyle.text12, TextStyle.flexWrap,
        TextStyle.colorWhite, { maxWidth: AppTheme.appWidth / 2 }]}>
            {location.name}, {reformatLocationString(
                location['flat_and_building'],
                location['locality'])}</Text>
    }

    ChangeLocationIconView() {
        return <Pressable onPress={() => {
            DeviceEventEmitter.emit('actionFromParent',
                { action: ActionFromParent.showLocationBottoSheet })
        }}><IconView size={20} icon={'edit_circle.svg'} /></Pressable>
    }

}

export default TabControllerView
